/* ═══════════════════════════════════
   ORDRÉE — theme.js
═══════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  // ── Header scroll shadow ──
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── Cart Drawer ──
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartBtns    = document.querySelectorAll('[data-cart-open]');
  const cartClose   = document.querySelector('.cart-close');

  function openCart()  {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
    cartDrawer?.setAttribute('aria-hidden', 'false');
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('active');
    document.body.style.overflow = '';
    cartDrawer?.setAttribute('aria-hidden', 'true');
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ── Add to Cart buttons ──
  document.querySelectorAll('.product-atc-btn, [data-atc]').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId || this.closest('form')?.querySelector('[name=id]')?.value;
      if (!variantId) return;

      const original = this.innerHTML;
      this.innerHTML = '⏳';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          this.innerHTML = '✓';
          this.style.background = 'var(--clr-sage)';
          await updateCartCount();
          setTimeout(() => openCart(), 400);
        }
      } catch(err) { console.error(err); }
      finally {
        setTimeout(() => {
          this.innerHTML = original;
          this.style.background = '';
          this.disabled = false;
        }, 1800);
      }
    });
  });

  // ── Cart Count ──
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent  = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch(e) {}
  }
  updateCartCount();

  // ── Quantity selectors ──
  document.querySelectorAll('.qty-selector').forEach(sel => {
    const numEl = sel.querySelector('.qty-num');
    sel.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        let val = parseInt(numEl.textContent) || 1;
        if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
        else val++;
        numEl.textContent = val;
        const input = sel.closest('form')?.querySelector('[name=quantity]');
        if (input) input.value = val;
      });
    });
  });

  // ── Accordion ──
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('open');
      trigger.closest('.product-accordion')?.querySelectorAll('.accordion-trigger').forEach(t => {
        t.classList.remove('open');
        t.nextElementSibling?.classList.remove('open');
      });
      if (!isOpen) {
        trigger.classList.add('open');
        body?.classList.add('open');
      }
    });
  });

  // ── Product thumbnails ──
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-main-img img');
      if (mainImg && thumb.querySelector('img')) {
        mainImg.src = thumb.querySelector('img').src.replace('_80x', '_800x');
      }
    });
  });

  // ── Filter buttons ──
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.collection-filters')?.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ── Fade-up on scroll ──
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-up');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.benefit-card, .testimonial-card, .step-item').forEach(el => {
    observer.observe(el);
  });

});
